import { render } from "./ExtraQuestionTextBox.vue?vue&type=template&id=1d7dfc40&scoped=true"
import script from "./ExtraQuestionTextBox.vue?vue&type=script&lang=js"
export * from "./ExtraQuestionTextBox.vue?vue&type=script&lang=js"

import "./ExtraQuestionTextBox.vue?vue&type=style&index=0&id=1d7dfc40&scoped=true&lang=scss"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7dfc40"]])

export default __exports__